import { memo } from "react";
import PropTypes from "prop-types";
import OffersOverview from "app/pages/.shared/OffersOverview/OffersOverview";
import { FormattedMessage } from "react-intl";
import { Button } from "app/components/ui/Button/Button";
import "./AsideOffersOverview.scss";
import PaymentDescriptionTermsContainer from "app/pages/Booking/Payment/PaymentDescriptionTerms/PaymentDescriptionTermsContainer";

const AsideOffersOverview = ({ offers = [], onClick, itemClickable = true, productPriceValue }) => {
	const offerCount = offers.length;

	return (
		<div className="aside-offers-overview">
			<div className="aside-offers-overview__offers">
				<OffersOverview offers={offers} clickable={itemClickable} />
				{productPriceValue && <PaymentDescriptionTermsContainer />}
			</div>
			<div className="aside-offers-overview__cta">
				<Button variant="primary" size="lg" fullWidth onClick={onClick}>
					{offerCount > 1 ? (
						<FormattedMessage id="product.page.aside.cta.label" />
					) : (
						<FormattedMessage id="product.page.aside.cta.label.single.offer" />
					)}
				</Button>
			</div>
		</div>
	);
};

AsideOffersOverview.propTypes = {
	offers: PropTypes.array,
	onClick: PropTypes.func,
	productPriceValue: PropTypes.string,
	itemClickable: PropTypes.bool,
};

export default memo(AsideOffersOverview);
